module.exports = __webpack_public_path__ + "images/profile-fan.png?4cf75";